import React from "react"
import PropTypes from "prop-types"
import { Link, TextSM } from "datastory-shared/ui"

export const Item = ({ selectedCategory, local_id: id, og_name }) => {
  const isSelected = selectedCategory === id

  return (
    <Link
      scroll={false}
      variant="standalone"
      href={id === "all" ? "/services/glossary" : `/services/glossary/${id}`}
      bg={isSelected && "blurble.50"}
      color={isSelected && "primary.500"}
      mx="xxs"
      mb="sm"
      px="md"
      py="xs"
      borderRadius="full"
      border={`1px solid`}
      borderColor={isSelected ? "primary.500" : "#C5BFD2"}
      cursor="pointer"
      _hover={{
        bg: "gray.50",
        textDecoration: "none",
      }}
      _focusWithin={{
        bg: "gray.50",
        borderColor: "primary.500",
      }}
      data-cy="tag"
    >
      <TextSM fontWeight={600} whiteSpace="nowrap">
        {og_name[0]?.i18n}
      </TextSM>
    </Link>
  )
}

Item.propTypes = {
  name: PropTypes.array,
  selectedCategory: PropTypes.string,
  id: PropTypes.string,
  setSelectedCategory: PropTypes.func,
}
